import React from 'react';
import StarListQuery from '../../../components/starListQuery/starListQuery';
import styles from './starList.module.scss';
class StarList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      totalNum: window.sessionStorage.getItem('totalStar') || 0
    }
  }
  componentDidMount() {
    console.log(this.props.location, 'this.props')
  }

  backHome = () => {
    console.log('backHome')
    this.props.showDynamic({
      starListShow: false,
      starInstructionShow: false
    })
  }

  render() {
    const { totalNum } = this.state;
    return (
      <div className={styles.starList}>
        <header className={styles.header}>
          <div className={styles.title}>
            <p>星星明细</p>
            <i onClick={() => this.backHome()}></i>
          </div>
          <p className={styles.totalNum}><span className={styles.totalDesc}>共有</span><span className={styles.num}>{totalNum}</span><i></i></p>
        </header>
        <StarListQuery />
      </div>
    )
  }
}
export default StarList;